export const CHANGE_DETAILS_OPEN_MODAL = "CHANGE_DETAILS_OPEN_MODAL";
export const CHANGE_DETAILS_CLOSE_MODAL = "CHANGE_DETAILS_CLOSE_MODAL";